import { all, takeLatest, fork, put, call } from 'redux-saga/effects';
import CompaniesApi from 'libs/api/companies';
import { setModalData } from 'redux/common/actions';
import routeCodes from 'common/constants/route-codes';
import UIHelper from 'services/UIHelper';
import { fetchAllPagesFromListApi } from 'utils/pagination';
import * as types from './types';

const api = new CompaniesApi();

function* getCompanies({ payload }) {
  try {
    const companies = yield call(fetchAllPagesFromListApi, api, {
      itemsKey: 'companies',
      params: payload?.params || {},
    });
    yield put({
      type: types.COMPANIES_GET_SUCCESS,
      payload: companies,
    });
  } catch (e) {
    yield put({
      type: types.COMPANIES_GET_FAILURE,
      payload: e?.response,
    });
  }
}

function* getById({ payload }) {
  try {
    const { data } = yield api.get(payload.id);
    yield put({
      type: types.COMPANIES_GET_BY_ID_SUCCESS,
      payload: data.company,
    });
  } catch (e) {
    yield put({
      type: types.COMPANIES_GET_BY_ID_FAILURE,
      payload: e?.response,
    });
  }
}

function* createOrUpdate({ payload }) {
  try {
    const { id, data, history } = payload;
    id
      ? yield api.put(id, { data })
      : yield api.create({
          data,
        });
    yield put({
      type: types.COMPANIES_CREATE_OR_UPDATE_SUCCESS,
    });
    UIHelper.showCreateOrUpdateSuccess();
    yield put({
      type: types.COMPANIES_GET_REQUEST,
      payload: {},
    });
    history?.push(routeCodes.profile);
  } catch (e) {
    yield put({
      type: types.COMPANIES_CREATE_OR_UPDATE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* deleteCompany({ payload }) {
  try {
    const { id, history } = payload;
    yield api.destroy(id);
    yield put({
      type: types.COMPANIES_DELETE_SUCCESS,
    });
    UIHelper.showSuccessMessage();

    yield put(
      setModalData({
        open: false,
        variant: 'primary',
        title: '',
        body: '',
        itemData: {},
      }),
    );
    yield put({
      type: types.COMPANIES_GET_REQUEST,
      payload: {},
    });
    history?.push(routeCodes.profile, { showDeleteSuccess: true });
  } catch (e) {
    yield put({
      type: types.COMPANIES_DELETE_FAILURE,
    });
  }
}

function* watchRestaurantListRequest() {
  yield takeLatest(types.COMPANIES_GET_REQUEST, getCompanies);
}

function* watchRestaurantCreateOrUpdateRequest() {
  yield takeLatest(types.COMPANIES_CREATE_OR_UPDATE_REQUEST, createOrUpdate);
}

function* watchRestaurantGetByIdRequest() {
  yield takeLatest(types.COMPANIES_GET_BY_ID_REQUEST, getById);
}

function* watchRestaurantDeleteRequest() {
  yield takeLatest(types.COMPANIES_DELETE_REQUEST, deleteCompany);
}

export default function* companySaga() {
  yield all([
    fork(watchRestaurantListRequest),
    fork(watchRestaurantCreateOrUpdateRequest),
    fork(watchRestaurantGetByIdRequest),
    fork(watchRestaurantDeleteRequest),
  ]);
}
